var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letter-jacket-package-image"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-10 col-sm-offset-1"},[_c('div',{staticClass:"product__main-img-wrapper product__main-img-wrapper--no-img-selection product__main-img-wrapper--border"},[_c('img',{staticClass:"responsive-img",attrs:{"src":_vm.packageImageUrl}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76154829","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/letter-jackets/catalog-details/components/LetterJacketPackageImage.vue
// module id = 1307
// module chunks = 0